<template>
    <div>
        <div class="top-box">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/site/site' }">场地管理</el-breadcrumb-item>
                <el-breadcrumb-item @click="back">案例列表</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="tab-list d_flex a_c ">
                <h2>新增场地案例</h2>
                <div class="item" @click="back"><i class="icon el-icon-caret-left" type="primary"></i>案例列表</div>
            </div>
        </div>
        <div class="page-content p20">
            <div class="from-box p20 bg_fff">
                <el-form ref="form" :model="form" label-width="120px" align="left" :rules="rules" >
                    <el-form-item label="场地名称" style="width: 350px;" prop="name">
                        <el-input v-model="name" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="活动标题" style="width: 350px;" prop="title">
                        <el-input v-model="form.title" ></el-input>
                    </el-form-item>
                    <el-form-item label="活动介绍" style="width: 350px;" prop="intro">
                        <el-input type="textarea" v-model="form.intro"></el-input>
                    </el-form-item>
                    <el-form-item  label="活动相册" style="width: 100%;" prop="imgs">
                        <el-upload class="avatar-uploader"
                                   ref="otherLicense"
                                   action
                                   :auto-upload="false"
                                   :on-preview="handlePicPreview"
                                   :on-remove="handleRemove"
                                   :file-list="form.imgs"
                                   :on-change="otherSectionFile"
                                   list-type="picture-card"
                                   multiple>
                            <i class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item  label="活动视频" style="width: 100%;" >
                        <el-upload class="avatar-uploader"
                                   ref="otherLicense"
                                   action
                                   :auto-upload="false"
                                   :on-preview="handlePicPreview1"
                                   :on-remove="handleRemove1"
                                   :file-list="form.videos"
                                   :on-change="otherSectionFile1"
                                   list-type="picture-card"
                                   multiple>
                            <i class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                    <el-button type="info" @click="caseList">取消</el-button>
                    <el-button type="primary" @click="addScave">{{case_id?'更新':'创建'}}</el-button>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import {setSiteCase,SiteCaseInfo} from '../../api/site'
    import { mapState } from 'vuex';
    export default {
        name: "add-case",
        data(){
            return{
                name:'',
                form:{
                    title:'',
                    intro:'',
                    space_id:'',
                    img:'',
                    imgs:[],
                    cover:'',
                    video:'',
                    videos:[],
                },
                case_id:'',
                rules:{
                    title: [
                        { required: true, message: '请输入案例标题', trigger: 'blur' }
                    ],
                    intro:[
                        { required: true, message: '请输入案例介绍', trigger: 'blur' }
                    ],
                    imgs:[
                        { required: true, message: '请选择案例图片', trigger: 'blur' }
                    ],
                },
                loading:false,
            }
        },
        computed:{
            ...mapState(['baseUrl'])
        },
        created(){
            this.form.space_id=this.$route.query.id;
            this.name=this.$route.query.name;
            this.case_id=this.$route.query.cid||'';
            if(this.case_id){
                this.getInfo();
            }
        },
        methods:{
            back(){
                this.$router.go(-1);
            },
            openFullScreen2() {
                this.loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
            },
            getInfo(){
                this.openFullScreen2();
                SiteCaseInfo({
                    case_id:this.case_id,
                }).then(res=>{
                    this.loading.close();
                    if(res.code==1){
                        this.form=res.data;
                        let arr=res.data.img.split(',');
                        if(arr.length>0){
                            this.form.imgs=arr.map((val,index)=>{
                                let obj={};
                                obj.uid=index;
                                obj.url=this.baseUrl+val;
                                obj.path=val;
                                return obj;
                            });
                        }
                        console.log(this.form);
                    }
                })
            },
            caseList(){
                this.$router.go(-1);
            },
            handlePicPreview(file){
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleRemove(file, fileList) {
                this.form.imgs.map((item,index)=>{
                    if(item.uid==file.uid){
                        this.form.imgs.splice(index,1)
                    }
                })
            },
            otherSectionFile(file){
                const typeArr = ['image/png', 'image/gif', 'image/jpeg', 'image/jpg'];
                const isJPG = typeArr.indexOf(file.raw.type) !== -1;
                const isLt3M = file.size / 1024 / 1024 < 30;
                if (!isJPG) {
                    this.$message.error('只能是图片!');
                    this.$refs.upload.clearFiles();
                    this.otherFiles = null;
                    return;
                }
                if (!isLt3M) {
                    this.$message.error('上传图片大小不能超过 30MB!');
                    this.$refs.upload.clearFiles();
                    this.otherFiles = null;
                    return;
                }
                this.otherFiles = file.raw;
                // FormData 对象
                var formData = new FormData();
                // 文件对象
                formData.append('image', this.otherFiles);
                formData.append('type', 'case');
                formData.append('is_cover', 0);
                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'token':localStorage.getItem('UTOKEN')
                    }
                }
                let baseURL= process.env.NODE_ENV==='development'?'/api/':'https://cdb.0731app.cn/';
                this.$axios.post(baseURL+"home/upload/image",formData,config).then(res=>{
                    console.log(res);
                    if(res.data.code==1){
                        let obj={
                            url:baseURL+res.data.data.path,
                            path:res.data.data.path,
                        };
                        this.form.imgs.push(obj);
                    }
                })
            },
            handlePicPreview1(file){
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleRemove1(file, fileList) {
                this.form.imgs.map((item,index)=>{
                    if(item.uid==file.uid){
                        this.form.imgs.splice(index,1)
                    }
                })
            },
            otherSectionFile1(file){
                const fileSize = file.size / 1024 / 1024 ;
                if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file.raw.type) == -1) {
                    this.$message.error("请上传正确的视频格式");
                    return false;
                }
                if (fileSize>50) {
                    this.$message.error('视频大小不能超过 50MB!');
                    return false;
                }
                this.otherFiles = file.raw;
                // FormData 对象
                var formData = new FormData();
                // 文件对象
                formData.append('video', this.otherFiles);
                formData.append('type', 'service');
                formData.append('is_cover', 0);
                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'token':localStorage.getItem('UTOKEN')
                    }
                }
                let baseURL= process.env.NODE_ENV==='development'?'/api/':'https://cdb.0731app.cn/';
                this.$axios.post(baseURL+"home/upload/video",formData,config).then(res=>{
                    console.log(res);
                    if(res.data.code==1){
                        let obj={
                            url:res.data.data.path,
                            path:res.data.data.path,
                        };
                        this.form.imgs.push(obj);
                    }
                })
            },
            addScave(){
                if(this.case_id){
                    this.form.case_id=this.case_id;
                }
                let arr=this.form.imgs.map(val=>{
                    return val.path;
                });
                this.form.cover=this.form.img=arr.join(',');
                setSiteCase(this.form).then(res=>{
                    if(res.code==1){
                        if(this.form.case_id){
                            this.$message.success('修改成功');
                        }else{
                            this.$message.success('创建成功');
                        }
                        this.$router.push({path:'/uploadFile/index',query:{id:this.form.space_id,name:this.name}});

                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>
